import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";

const routes: Array<RouteRecordRaw> = [
  //pages authentiacation
  {
    path: "/:company",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "sign-in",
        name: "sign-in",
        component: () => import("@/views/auth/basic-flow/SignIn.vue"),
        meta: {
          pageTitle: "Iniciar sesión",
        },
      },
    ],
    redirect: (to) => {
      return `/${to.params.company}/sign-in`;
    },
  },
  //una vez logueado
  {
    path: "/:company",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Dashboard",
          breadcrumbs: ["Dashboards"],
        },
      },

      {
        path: "welcome",
        name: "welcome",
        component: () => import("@/views/Welcome.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Welcome",
          breadcrumbs: ["Welcome"],
        },
      },
      /*
      {
        path: "/officers",
        name: "officers",
        component: () => import("@/views/oficiales/Index.vue"),
        meta: { requiresAuth: true, pageTitle: "Oficiales", breadcrumbs: ["Oficiales"]}
      },
      */
      {
        path: "planilla",
        name: "planilla",
        component: () => import("@/views/planilla/Index.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Planilla",
          breadcrumbs: ["Mantenimiento", "Planilla"],
        },
        props: true,
      },
      {
        path: "seats",
        name: "seats",
        component: () => import("@/views/seats/Index.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Filiales",
          breadcrumbs: ["Mantenimiento", "Filiales"],
        },
        props: true,
      },
      {
        path: "functions",
        name: "funciones",
        component: () => import("@/views/functions/Index.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Funciones",
          breadcrumbs: ["Mantenimiento", "Funciones"],
        },
        props: true,
      },
      {
        path: "payment-control",
        name: "PaymentControl",
        component: () => import("@/views/payments/Index.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Control de Pagos",
          breadcrumbs: ["Control", "Pagos"],
        },
        props: true,
      },
      {
        path: "payment-control/:id/manager",
        name: "PaymentControlDetails",
        component: () => import("@/views/payments/Details.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Control de Pagos",
          breadcrumbs: ["Control", "Pagos", "Detalle"],
        },
      },

      {
        path: "support",
        name: "tutos",
        component: () => import("@/views/support/Tutoriales.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Tutoriales",
          breadcrumbs: ["Tutoriales"],
        },
      },
      /*
      {
        path: "tutoriales",
        name: "tutoriales",
        component: () => import("@/views/tutoriales/Index.vue"),
        meta: { requiresAuth: true, pageTitle: "Tutoriales", breadcrumbs: ["Tutoriales"]}
      },
      */
      {
        path: "tournaments",
        name: "tutoriales",
        component: () => import("@/views/tournaments/Index.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Torneos",
          breadcrumbs: ["Torneos"],
        },
      },
      {
        path: "tournaments/:id/manager",
        name: "tournament-manager",
        component: () => import("@/views/tournaments/pages/Manager.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Torneos",
          breadcrumbs: ["Torneos", "evento"],
        },
        children: [
          {
            path: "home",
            name: "tournament-home",
            component: () => import("@/views/tournaments/pages/Home.vue"),
            meta: {
              pageTitle: "Torneos | Inicio",
              breadcrumbs: ["Torneos", "Inicio"],
            },
          },
          {
            path: "sports",
            name: "tournament-sports",
            component: () => import("@/views/tournaments/pages/Sports.vue"),
            meta: {
              pageTitle: "Torneos | Deportes",
              breadcrumbs: ["Torneos", "Deportes"],
            },
          },
          {
            path: "forms",
            name: "tournament-forms",
            component: () => import("@/views/tournaments/pages/Forms.vue"),
            meta: {
              pageTitle: "Torneos | Formularios",
              breadcrumbs: ["Torneos", "Formularios"],
            },
          },
        ],
      },

      //manager
      {
        path: "acreditation",
        name: "acreditation",
        component: () => import("@/views/acrd/Index.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Acreditación",
          breadcrumbs: ["Acreditación"],
        },
      },
      {
        path: "acreditation/:id/manager",
        name: "acrd-manager",
        component: () => import("@/views/acrd/Manager.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Acreditación",
          breadcrumbs: ["Acreditación", "Evento"],
        },
        children: [
          {
            path: "home",
            name: "acrd-home",
            component: () => import("@/views/acrd/pages/Home.vue"),
            meta: {
              pageTitle: "Acreditación | Inicio",
              breadcrumbs: ["Acreditación", "Inicio"],
            },
          },
          {
            path: "forms",
            name: "acrd-forms",
            component: () => import("@/views/acrd/pages/Forms.vue"),
            meta: {
              pageTitle: "Acreditación | Formularios",
              breadcrumbs: ["Acreditación", "Formularios"],
            },
          },
          {
            path: "sports",
            name: "acrd-sports",
            component: () => import("@/views/acrd/pages/Sports.vue"),
            meta: {
              pageTitle: "Acreditación | Deportes",
              breadcrumbs: ["Acreditación", "Deportes"],
            },
          },
          {
            path: "clubs",
            name: "acrd-clubs",
            component: () => import("@/views/acrd/pages/Clubs.vue"),
            meta: {
              pageTitle: "Acreditación | Instituciones",
              breadcrumbs: ["Acreditación", "Instituciones"],
            },
          },
          {
            path: "documents",
            name: "acrd-documents",
            component: () => import("@/views/acrd/pages/Documents.vue"),
            meta: {
              pageTitle: "Acreditación | Documentos",
              breadcrumbs: ["Acreditación", "Documentos"],
            },
          },
        ],
      },
      {
        path: "events",
        name: "Events",
        component: () => import("@/views/events/Index.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Eventos",
          breadcrumbs: ["Eventos"],
        },
      },
      //manager event
      {
        path: "events/:id/manager",
        name: "EventManager",
        component: () => import("@/views/events/manager/Index.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Gestión del evento",
          breadcrumbs: ["Eventos", "Gestión"],
        },
        children: [
          {
            path: "home",
            name: "manager-home",
            component: () => import("@/views/events/manager/pages/Home.vue"),
            meta: {
              pageTitle: "Eventos | Inicio",
              breadcrumbs: ["Eventos", "Inicio"],
            },
          },
          {
            path: "forms",
            name: "manager-forms",
            component: () => import("@/views/events/manager/pages/Forms.vue"),
            meta: {
              pageTitle: "Eventos | Formularios",
              breadcrumbs: ["Eventos", "Formularios"],
            },
          },
          {
            path: "sports",
            name: "manager-sports",
            component: () => import("@/views/events/manager/pages/Sports.vue"),
            meta: {
              pageTitle: "Eventos | Deportes",
              breadcrumbs: ["Eventos", "Deportes"],
            },
          },
          {
            path: "medals",
            name: "medals-gral-manager",
            component: () =>
              import("@/views/events/manager/pages/medals/Index.vue"),
            meta: {
              pageTitle: "Eventos | Medallero",
              breadcrumbs: ["Eventos", "Medallero"],
            },
          },
        ],
      },
      /*
      {
        path: "consolidate/:slug",
        name: "ConsolidateDetails",
        component: () => import("@/views/events/Details.vue"),
        meta: { requiresAuth: true, pageTitle: "Consolidados", breadcrumbs: ["Consolidados", "Evento"], }
      },
      */
      {
        path: "institutions",
        name: "Clubs",
        component: () => import("@/views/clubs/Index.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Instituciones",
          breadcrumbs: ["Instituciones"],
        },
      },
      {
        path: "institutions/:id",
        name: "manager-clubs",
        component: () => import("@/views/clubs/pages/Manager.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Instituciones",
          breadcrumbs: ["Instituciones", "Administrador"],
        },
        children: [
          {
            path: "repman",
            name: "manager-clubs-repman",
            component: () => import("@/views/clubs/pages/Repman.vue"),
            meta: {
              pageTitle: "Instituciones | Representantes",
              breadcrumbs: ["Instituciones", "Representantes"],
            },
          },
          {
            path: "users",
            name: "clubs-users",
            component: () => import("@/views/clubs/pages/Users.vue"),
            meta: {
              pageTitle: "Instituciones | Usuarios",
              breadcrumbs: ["Instituciones", "Usuarios"],
            },
          },
        ],
      },
      {
        path: "sports",
        name: "Sports",
        component: () => import("@/views/sports/Index.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Deportes",
          breadcrumbs: ["Deportes"],
        },
      },
      {
        path: "persons",
        name: "Participantes",
        component: () => import("@/views/persons/Index.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Participantes",
          breadcrumbs: ["Mantenimiento", "Participantes"],
        },
      },
      {
        path: "users",
        name: "Users",
        component: () => import("@/views/users/Index.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Usuarios",
          breadcrumbs: ["Seguridad", "Usuarios"],
        },
      },

      //System
      {
        path: "system",
        name: "SystemManager",
        component: () => import("@/views/system/SystemManager.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "System",
          breadcrumbs: ["System", "Modulos"],
        },
        children: [
          {
            path: "",
            component: () => import("@/views/system/module/ModuleIndex.vue"),
          },
          {
            path: "user",
            name: "UserIndex",
            component: () => import("@/views/system/user/UserIndex.vue"),
            meta: {
              requiresAuth: true,
              pageTitle: "Usuarios del Sistema",
              breadcrumbs: ["System", "Users"],
            },
          },
          {
            path: "module",
            name: "ModuleIndex",
            component: () => import("@/views/system/module/ModuleIndex.vue"),
            meta: {
              requiresAuth: true,
              pageTitle: "Gestion de Menú",
              breadcrumbs: ["System", "Menú"],
            },
          },
        ],
      },

      //SECCIÓN ACADEMICA
      {
        path: "academic",
        name: "Academic",
        component: () => import("@/views/academic/Index.vue"),
        meta: {
          requiresAuth: true,
          pageTitle: "Academic",
          breadcrumbs: ["Academic", "Inicio"],
        },
        children: [
          {
            path: "",
            component: () => import("@/views/public/categorie/Index.vue"),
          },
          {
            path: "students",
            name: "Students",
            component: () => import("@/views/academic/students/Index.vue"),
            meta: {
              requiresAuth: true,
              pageTitle: "Estudiantes",
              breadcrumbs: ["Academic", "Estudiantes"],
            },
          },
          {
            path: "matters",
            name: "Matters",
            component: () => import("@/views/academic/matters/Index.vue"),
            meta: {
              requiresAuth: true,
              pageTitle: "Temas",
              breadcrumbs: ["Academic", "Temas"],
            },
          },
        ],
      },
    ],
  },
  //RUTAS PUBLICA
  //descarga de certificados
  {
    path: "/:company/certificate",
    name: "certificate",
    component: () => import("@/views/public/certificate/Index.vue"),
    meta: { pageTitle: "Descarga de certificados deportivos y académicos" },
  },
  //Registro de Instituciones publico
  {
    path: "/:company/register",
    component: () => import("@/views/public/institution/RegisterIndex.vue"),
    meta: { pageTitle: "Registro" },
  },

  //eventos publicos
  {
    path: "/public",
    component: () => import("@/views/public/tournaments/Layout.vue"),
    children: [
      {
        path: "medals",
        name: "public-medals",
        component: () => import("@/views/public/medals/Index.vue"),
        meta: { pageTitle: "Medallero", breadcrumbs: ["Medallero"] },
      },
      {
        path: "medals/:id",
        name: "medals-gral",
        component: () => import("@/views/public/medals/Sport.vue"),
        meta: {
          pageTitle: "Eventos | Medallero por deporte",
          breadcrumbs: ["Eventos", "Medallero por deporte"],
        },
      },

      {
        path: "tournaments",
        name: "public-tournaments",
        component: () => import("@/views/public/tournaments/Index.vue"),
        meta: { pageTitle: "Torneos", breadcrumbs: ["Torneos"] },
      },
      {
        path: "tournaments/:id",
        name: "public-tournament-manager",
        component: () => import("@/views/public/tournaments/Manager.vue"),
        meta: { pageTitle: "Torneos", breadcrumbs: ["Torneos", "evento"] },
        children: [
          {
            path: "sports",
            name: "sports",
            component: () =>
              import("@/views/public/tournaments/pages/Sports.vue"),
            meta: {
              pageTitle: "Torneos | Deportes",
              breadcrumbs: ["Torneos", "Deportes"],
            },
          },
          {
            path: "teams",
            name: "teams",
            component: () =>
              import("@/views/public/tournaments/pages/Teams.vue"),
            meta: {
              pageTitle: "Torneos | Equipos",
              breadcrumbs: ["Torneos", "Equipos"],
            },
          },
        ],
      },
      //Detalle del evento -> deporte
      {
        path: "tournaments/:idevent/:idsport",
        name: "public-manager-sport",
        component: () =>
          import("@/views/public/tournaments/pages/sports/Manager.vue"),
        children: [
          {
            path: "teams",
            name: "public-sport-teams",
            component: () =>
              import("@/views/public/tournaments/pages/sports/Teams.vue"),
            meta: {
              pageTitle: "Torneos | Deportes | Equipos",
              breadcrumbs: ["Sports", "Equipos"],
            },
          },
          {
            path: "teams/:idteam",
            name: "public-sport-teams-nominal",
            component: () =>
              import("@/views/public/tournaments/pages/sports/Nominal.vue"),
            meta: {
              pageTitle: "Torneos | Deportes | Equipos",
              breadcrumbs: ["Sports", "Equipos"],
            },
          },

          {
            path: "fixture",
            name: "public-sport-fixture",
            component: () =>
              import("@/views/public/tournaments/pages/sports/Fixture.vue"),
            meta: {
              pageTitle: "Torneos | Deportes | Equipos",
              breadcrumbs: ["Sports", "Equipos"],
            },
          },
          {
            path: "meetings",
            name: "public-meetings",
            component: () =>
              import("@/views/public/tournaments/pages/sports/Meetings.vue"),
            meta: {
              pageTitle: "Torneos | Deportes | Equipos",
              breadcrumbs: ["Sports", "Equipos"],
            },
          },
          {
            path: "goalscorers",
            name: "public-goalscorers",
            component: () =>
              import("@/views/public/tournaments/pages/sports/Goalscorers.vue"),
            meta: {
              pageTitle: "Torneos | Deportes | Goleadores",
              breadcrumbs: ["Sports", "Goleadores"],
            },
          },
          {
            path: "winscore",
            name: "public-sport-winscore",
            component: () =>
              import("@/views/public/tournaments/pages/sports/WinScore.vue"),
            meta: {
              pageTitle: "Torneos | Deportes | Resultados",
              breadcrumbs: ["Sports", "Resultados"],
            },
          },
          {
            path: "cards",
            name: "public-sport-cards",
            component: () =>
              import("@/views/public/tournaments/pages/sports/Cards.vue"),
            meta: {
              pageTitle: "Torneos | Deportes | Resultados",
              breadcrumbs: ["Sports", "Tarjetas"],
            },
          },
          {
            path: "ranking",
            name: "ranking-teams",
            component: () =>
              import(
                "@/views/public/tournaments/pages/sports/RankingTeams.vue"
              ),
            meta: {
              pageTitle: "Torneos | Deportes | Ranking",
              breadcrumbs: ["Sports", "Ranking de equipos"],
            },
          },
        ],
      },
    ],
  },

  //registro de jueces
  {
    path: "/jude/:id",
    name: "register-jude",
    component: () => import("@/views/public/jude/Index.vue"),
  },

  // ── Sección pública de eventos por company | TEMPORALMENTE FUERA POR CONFLICTO──
  /*
  {
    path: "/:company",
    component: () => import("@/views/public/events/Layout.vue"),
    children: [
      {
        path: "organizer",
        name: "public-company-events",
        component: () => import("@/views/public/events/Index.vue"),
        meta: { pageTitle: "Eventos" },
      },
      {
        path: "event/:slug",
        name: "public-company-event-detail",
        component: () => import("@/views/public/events/Show.vue"),
        meta: { pageTitle: "Detalle del Evento" },
      },

      {
        path: "event/:slug/register/:sport",
        name: "acrd-public-register",
        component: () => import("@/views/public/acrd/RegisterIndex.vue"),
        meta: { pageTitle:"Registro de personal externo"},
      },
    ],
  },
  */

  {
    // the 404 route, no authorize
    path: "/403",
    name: "403",
    component: () => import("@/views/auth/Error403.vue"),
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/auth/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/auth/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  // Establecer el título de la página
  document.title = `${to.meta.pageTitle} - ${process.env.VUE_APP_NAME}`;

  // Resetear la configuración de diseño
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  // Obtener el parámetro de organización si existe
  const company = to.params.company || "default"; // Puedes cambiar "default" por otro valor

  // Si la ruta requiere autenticación
  if (to.meta.requiresAuth) {
    // Verificar si el usuario está autenticado
    if (!store.getters.isUserAuthenticated && to.name !== "sign-in") {
      return next({ name: "sign-in", params: { company } });
    }

    try {
      await store.dispatch(Actions.VERIFY_ACCESS, { tag: to.path });
    } catch (error) {
      return next({ name: "sign-in", params: { company } });
    }
  }

  // Desplazamiento suave al inicio de la página
  setTimeout(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, 100);

  next();
});

export default router;
